import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"
import Index from "Components/Dashboard/Index"

const Dashboard = () => <Switch><Route exact path="/dashboard"><Index /></Route></Switch>

export default withRouter(Dashboard)